import "./styles.css";
import { loadAds, subscribeRealtime, isConnected, getAds } from "./ads-state.js";
import { initAdsTable } from "./ui/ads-table.js";
import { openFormModal } from "./ui/form-modal.js";
import { exportZip } from "./export-zip.js";
import { toast } from "./ui/toast.js";

function setConnect(connected) {
  const dot = document.getElementById("connect-dot");
  const label = document.getElementById("connect-label");
  if (!dot || !label) return;
  if (connected) {
    dot.className = "w-2 h-2 rounded-full bg-emerald-500";
    label.textContent = "Bağlı (eş zamanlı)";
    label.className = "text-emerald-400";
  } else {
    dot.className = "w-2 h-2 rounded-full bg-amber-500 animate-pulse";
    label.textContent = "Bağlanıyor…";
    label.className = "text-amber-400";
  }
}

function updateExportButton() {
  const btn = document.getElementById("export-zip-btn");
  if (!btn) return;
  btn.disabled = getAds().length === 0;
}

async function bootstrap() {
  if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_ANON_KEY) {
    toast(
      "Supabase env eksik — .env.local içine VITE_SUPABASE_URL ve VITE_SUPABASE_ANON_KEY ekle",
      "error"
    );
    return;
  }

  initAdsTable();

  document.getElementById("add-ad-btn").addEventListener("click", () =>
    openFormModal()
  );
  document.getElementById("export-zip-btn").addEventListener("click", async () => {
    try {
      const r = await exportZip();
      toast(`${r.count} reklam ZIP olarak indirildi`, "ok");
    } catch (err) {
      toast(err.message || "Export hatası", "error");
    }
  });

  subscribeRealtime((connected) => setConnect(connected));

  try {
    await loadAds();
    updateExportButton();
  } catch (err) {
    toast("Yüklenemedi: " + (err.message || "?"), "error");
  }

  // Listener: ad count > 0 olunca export butonu aktif
  const obs = new MutationObserver(updateExportButton);
  const target = document.getElementById("ads-table-host");
  if (target) obs.observe(target, { childList: true, subtree: true });
}

bootstrap();
